<template>
  <div>
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-header">
              <h3 class="box-title">OAuth2</h3>
            </div>
            <!-- /.box-header -->
            <div
              class="box-body table-responsive no-padding"
            >
              <table class="table table-hover">
                <tbody>
                  <tr>
                    <th>Name</th>
                    <th>App Name</th>
                    <th>Description</th>
                    <th>Domain</th>
                    <th>Action</th>
                  </tr>
                  <tr
                    v-for="item in list"
                    v-bind:key="item.id"
                  >
                    <td>{{item.name}}</td>
                    <td>{{item.appname}}</td>
                    <td>{{item.description}}</td>
                    <td>{{item.domain}}</td>
                    <td>
                      <button
                        class="btn btn-info btn-sm btn-agent-edit pull-right"
                        data-toggle="modal"
                        v-on:click="handleEdit(item)"
                      >Edit</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->
        </div>
      </div>
    </section>
    <!-- /.content -->

    <oauth-modal
      type="edit"
      :fetch="fetch"
      ref="modalEdit"
    />
    <oauth-modal
      type="create"
      :fetch="fetch"
      ref="modalCreate"
    />

    <!-- add Agent -->
    <div
      class="add-app-bgcolor dropup"
      v-show="isAdminInApp"
    >
      <button class="add-app-btn" v-on:click="handleCreate">
        <span class="btn add-app">
          <i class="fa fa-plus"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import utils from "../../utils";
import OauthModal from "../modules/OauthModal";

export default {
  name: "oauth2-list",
  components: {
    OauthModal
  },
  data() {
    return {
      list: []
    };
  },
  computed: {
    isAdminInApp() {
      return utils.checkIsAppAdmin();
    }
  },
  methods: {
    async fetch() {
      const { appid } = this.$route.query;
      const list = await api.post({
        path: "/oauth2/get?_type=json",
        data: { appid },
        withLoading: true
      });
      this.list = list;
    },
    handleCreate() {
      this.$refs.modalCreate.show();
    },
    handleEdit(item) {
      this.$refs.modalEdit.show(item);
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// OAuth2List.vue?47aaab7e